<template>
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Data</th>
        <th>Ora</th>
        <th class="text-end">Temperatura</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="temperature in temperatures"
        :key="temperature.id"
        :temperature="temperature"
      >
        <td>
          {{ formatDate(temperature.createdAt) }}
        </td>
        <td>
          {{ formatTime(temperature.createdAt) }}
        </td>
        <td class="text-end">{{ temperature.measure }} °C</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
/* Helpers */
import FormatHelper from '@/helpers/format.helper'

export default {
  name: 'TemperatureLog',
  props: {
    temperatures: Array
  },
  methods: {
    formatDate: function(date) {
      return FormatHelper.formatDate(date)
    },
    formatTime: function(date) {
      return FormatHelper.formatTime(date)
    }
  }
}
</script>
